
export default {
  getVessel: state => {
    return state.vessel;
  }
}
